import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { CicAppState } from './models/app-models';
import { Notification, NotificationStatus } from '../../pages/notification/notification-models';
import { MapNotification } from '../../global/helpers/form-data-helper';
import { TcsmSiteSettingsProps } from '../../global/models/epi-model';
import { NotificationsModal } from './notifications-modal';

export const NotificationBell = () => {
	const [modalOpen, setModalOpen] = useState(false);

	const siteSettings = useSelector<CicAppState, TcsmSiteSettingsProps>(
		state => state.epiProps?.siteSettingsState?.siteSettings,
	);

	const notifications = useSelector<CicAppState, Notification[]>(
		state => state.notificationState?.notifications?.filter(n => n.display_cpg),
	)?.map(n => MapNotification(n, siteSettings?.notificationMapping));

	const hasUnread = notifications?.some(
		n => n.notification_status === NotificationStatus.INITIAL,
	);

	const handleClick = () => {
		setModalOpen(prev => !prev);
	};

	const handleClose = () => {
		setModalOpen(false);
	};

	const viewAllUrl = '/services/mycpg/notifications?tab=all';

	return (
		<span className="notification-bell-container">
			<button
				type="button"
				className={`notification-bell ${hasUnread ? 'new-notification' : ''} ${modalOpen ? 'is-active' : ''}`}
				onClick={handleClick}
				aria-label="Notifications"
				aria-expanded={modalOpen}
				aria-haspopup="dialog"
			>
				<svg className="info-icon" aria-hidden="true" focusable="false">
					<use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="#bell-icon-outline" />
				</svg>
				<span className="visually-hidden">Notifications</span>
			</button>
			<NotificationsModal
				open={modalOpen}
				handleClose={handleClose}
				notifications={notifications || []}
				viewAllUrl={viewAllUrl}
				mandatoryTooltip={siteSettings?.mandatoryNotificationTooltip}
			/>
		</span>
	);
};
